import { Component, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';

import { LayoutService } from './layout.service';
import { SharedModule } from 'src/app/features/shared/shared.module';
import { CoreModule } from '../core.module';
import { HeaderComponent } from 'src/app/features/shared/header/container/header.component';
import { AppMaterialModule } from 'src/app/features/shared/material.module';
import { MenuComponent } from '../menu/container/menu/menu.component';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['../core.scss', './layout.component.scss'],
    standalone: true,
    imports: [
        AppMaterialModule,
        SharedModule,
        HeaderComponent,
        MenuComponent,
    ]
})
export class LayoutComponent implements OnInit, OnDestroy {
    @ViewChild('sidenav') private sideNav: MatDrawer;

    private sideNavEmitSubscr: Subscription;

    email = '';
    selected: string;
    events: string[] = [];
    opened: boolean;

    constructor(
        private layoutService: LayoutService,
    ) {}

    ngOnInit() {
        this.sideNavEmitSubscr = this.layoutService.getSideNav().subscribe(() => {
            this.toggleSideNav();
        });

        // this.router.events
        //     .pipe(
        //         filter(
        //             (event) =>
        //                 event instanceof NavigationStart
        //                 || event instanceof NavigationEnd
        //                 || event instanceof NavigationCancel
        //                 || event instanceof NavigationError
        //         )
        //     )
        //     .subscribe((event) => {
        //         if (event instanceof NavigationStart) {
        //             this.loadingService.add();
        //             return;
        //         }

        //         this.loadingService.remove();
        //     });
    }

    toggleSideNav() {
        this.sideNav.toggle();
    }

    ngOnDestroy() {
        this.sideNavEmitSubscr?.unsubscribe();
    }
}
